import { Component, OnDestroy, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';
import { NbSearchService, NbSearchComponent } from '@nebular/theme';
import { UserData } from '../../../@core/data/users';
import { LayoutService } from '../../../@core/utils';
import { map, takeUntil } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';
import { MENU_ITEMS } from '../../../pages/pages-menu';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
  standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy, AfterViewInit {
  private searchSubscription: Subscription;
  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  user: any;

  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];

  currentTheme = 'default';

  userMenu = [{ title: 'Profile' }, { title: 'Log out' }];
  value = '';

  @ViewChild('searchComponent') searchComponent: NbSearchComponent;
  constructor(
    private router: Router,
    private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private userService: UserData,
    private layoutService: LayoutService,
    private breakpointService: NbMediaBreakpointsService,
    private searchService: NbSearchService) {
    this.searchService.onSearchSubmit()
      .subscribe((data: any) => {
        this.value = data.term;
        console.log(this.value);

        // Iterate through routes
        for (let item of MENU_ITEMS) {
          // Check if there are any children
          if (item.children) {
            for (let child of item.children) {
              // Check if the title starts with the search term
              if (child.title.toLowerCase().startsWith(this.value.toLowerCase())) {
                // Navigate to the matching route
                this.router.navigate([child.link]);
                return;
              }
            }
          } else if (item.title.toLowerCase().startsWith(this.value.toLowerCase())) {
            // Check if the title starts with the search term for a parent item
            this.router.navigate([item.link]);
            return;
          }
        }
      });

  }

  ngOnInit() {
    this.currentTheme = this.themeService.currentTheme;

    this.userService.getUsers()
      .pipe(takeUntil(this.destroy$))
      .subscribe((users: any) => this.user = users.nick);

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);

    this.router.events.pipe(
      // Filter for NavigationEnd events
      filter(event => event instanceof NavigationEnd),
      takeUntil(this.destroy$)
    ).subscribe((event: NavigationEnd) => {
      // Check if the URL matches the specific route
      if (event.urlAfterRedirects === '/pages/ai/gans') {
        this.toggleSidebar();
      }
    });
  }

  ngAfterViewInit() {
    // Auto-open search only on the home route
    setTimeout(() => {
      if (this.searchComponent && this.isHomeRoute()) {
        this.searchComponent.openSearch();
      }
    }, 100);
  }

  ngOnDestroy() {
    this.searchSubscription.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }

  search(event) {
    console.log(event);
  }

  /** True only when on the home route (dashboard); search auto-opens only there. */
  private isHomeRoute(): boolean {
    const url = this.router.url.split('?')[0].replace(/\/$/, '');
    return url === '/pages' || url === '/pages/dashboard';
  }
}
